<div
  ngTabList
  class="tab-list"
  [attr.aria-label]="ariaLabel()"
  [selectedTab]="activeTab()"
  (selectedTabChange)="select($event)">
  @for (tab of tabs(); track tab.value()) {
    <button
      ngTab
      class="tab"
      [value]="tab.value()"
      [disabled]="tab.disabled()">
      {{ tab.label() }}
    </button>
  }
</div>

@for (tab of tabs(); track tab.value()) {
  <div
    ngTabPanel
    class="tab-panel"
    [value]="tab.value()"
    [preserveContent]="true">
    <ng-template ngTabContent>
      <ng-container [ngTemplateOutlet]="tab.content()" />
    </ng-template>
  </div>
}
